export default function RouteLoader({
  label = "Loading your workspace",
  hint = "Warming up data and visuals.",
}) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="relative w-full max-w-md overflow-hidden rounded-3xl border border-yellow-400/20 bg-gradient-to-br from-[#171717] via-[#171717] to-[#171717] px-8 py-10 text-center shadow-2xl">
        <div className="absolute -top-20 -right-16 h-40 w-40 rounded-full bg-yellow-400/10 blur-3xl" />
        <div className="absolute -bottom-24 -left-10 h-48 w-48 rounded-full bg-orange-500/10 blur-3xl" />

        <div className="relative mx-auto mb-6 h-16 w-16">
          <div className="absolute inset-0 rounded-full border border-yellow-400/40 animate-spin" />
          <div className="absolute inset-2 rounded-full border border-orange-400/30" />
          <span className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-yellow-400 shadow-[0_0_12px_rgba(250,204,21,0.65)] animate-pulse" />
        </div>

        <h2 className="text-lg font-semibold text-white">{label}</h2>
        <p className="mt-2 text-sm text-gray-400">{hint}</p>

        <div className="mt-6 h-2 w-full overflow-hidden rounded-full bg-[#171717]">
          <div className="h-full w-1/2 rounded-full bg-gradient-to-r from-yellow-400 via-amber-300 to-orange-400 animate-pulse" />
        </div>
      </div>
    </div>
  );
}
